<template lang="html">

  <section class="banner-experiencia column-center animation" id="experiencia" :style="'background:url(/static/img/'+$t(`productos.${data}.banner_experiencia.enlace`)+'/background-intro-'+$t(`productos.${data}.banner_experiencia.enlace`)+'.jpg) center/cover no-repeat'">
    <div class="container -xxs textos">
      <router-link class="enlace-cover" :to="$t('enlaces.'+$t(`productos.${data}.banner_experiencia.enlace`))"></router-link>
      <h2 class="title -xs">{{$t(`productos.${data}.banner_experiencia.titulo`)}}</h2>
      <router-link class="btn" :to="$t('enlaces.'+$t(`productos.${data}.banner_experiencia.enlace`))">
        <span>{{$t(`productos.${data}.banner_experiencia.boton`)}}</span>
      </router-link>
    </div>

  </section>


  
</template>

<script lang="js">
  export default  {
    name: 'banner-experiencia',
    props : ['data']
}
</script>

<style scoped lang="scss">
.banner-experiencia {
  padding: 100px 0;
  height: 390px;
  position: relative;
  overflow: hidden;

  .container{
    max-width: 768px;
  }

  .title{
    margin-bottom: 30px;
    text-align: center;
    line-height: 40px;
    transform: translateY(500px);
    opacity: 0;
    transition: 1s;
  }

  .btn{
    position: relative;
    z-index: 6;
    transform: translateY(500px);
    opacity: 0;
    transition: 1s;
    transition-delay: .5s;
  }

  &.launched{
    .title, .btn{
      opacity: 1;
      transform: translateY(0);
    }
  }
}

@media screen and (max-width: 700px){
  .banner-experiencia .title{
    line-height: 25px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/views/productos/banner-experiencia.vue